import { render, staticRenderFns } from "./Tti.vue?vue&type=template&id=17719062&"
import script from "./Tti.vue?vue&type=script&lang=js&"
export * from "./Tti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports